import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ChevronRight } from 'lucide-react';
import './schrank-workspace.css';

export function SchrankSectionHeader({ title, description, context }) {
  return (
    <header className="schrank-section-header">
      <nav aria-label="Bereichsnavigation" className="schrank-breadcrumb">
        <Link to="/schrank"><ArrowLeft size={14} /> Schränke</Link>
        <ChevronRight size={13} aria-hidden="true" /><span>{title}</span>
      </nav>
      <div className="schrank-heading-row"><div>
        <h1>{title}</h1>
        {description && <p>{description}</p>}
      </div>{context && <div className="schrank-context">{context}</div>}</div>
    </header>
  );
}
